import { yup } from '@guiker/yup-util'

export const readOneBackgroundCheckPathValidator = yup.object({
  applicantId: yup.string().required(),
})
